// src/lib/utils/helpers.ts
export const formatCurrency = (amount: number, currencyCode: string = 'XOF'): string => {
  return amount.toLocaleString('fr-FR', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatDate = (date: any): string => {
  if (!date) return 'N/A';
  
  try {
    const dateObj = date.toDate ? date.toDate() : new Date(date);
    return dateObj.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return 'N/A';
  }
};

export const getFirstName = (fullName?: string): string => {
  if (!fullName) return 'Utilisateur';
  const parts = fullName.split(' ');
  return parts[0] || 'Utilisateur';
};